import type ProgramSearchHit from "@travily/types/pending/models/ProgramSearchHit";
import type { ProgramCardProgram } from "@/components/ProgramCard/ProgramCard";

/** Maps an OpenSearch program hit onto the shape `ProgramCard` expects. */
export function hitToProgram(hit: ProgramSearchHit): ProgramCardProgram {
  return {
    id: hit.sqid,
    name: hit.name,
    tagline: hit.tagline,
    community_program: hit.community_program,
    drop_off_available: hit.drop_off_available,
    featured: hit.featured,
    min_age: hit.min_age,
    max_age: hit.max_age,
    instruction_languages: hit.instruction_languages,
    influences: hit.influences,
    photos: hit.photos.map((image, i) => ({ id: `${hit.sqid}-${i}`, position: i, image })),
    account: {
      id: hit.account.id,
      handle: hit.account.handle,
      profile_type: (hit.account.profile_type ?? "Community") as "Family" | "Community" | "Individual" | "Personal",
      name: hit.account.display_name,
      avatar: hit.account.avatar,
      setup_completed: true,
      initial: hit.account.initial,
      display_name: hit.account.display_name,
      color: hit.account.color,
    },
  };
}
